<template>
  <v-row>
    <v-col cols="12" lg="12">
      <v-card>
        <v-toolbar flat>
          <v-col cols="12" class="px-0">
            <div class="d-flex align-center">
              <div class="text-left">
                <v-toolbar-title class="page-title">
                  Check Reference
                </v-toolbar-title>
              </div>
              <div class="ml-auto">
                <!-- <v-btn color="primary" @click="addOlt()">
                  <v-icon class="mr-2">mdi-plus</v-icon> Add
                </v-btn> -->
                <!-- <v-btn color="primary" class="ml-2" @click="goBack()">
                  <v-icon class="mr-2">mdi-plus</v-icon> Add Serial
                </v-btn> -->
              </div>
            </div>
          </v-col>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-divider></v-divider>

        <v-card-title>
          <v-text-field
            v-model="searchVal"
            append-icon="mdi-magnify"
            label="Search by Reference Number"
            single-line
            hide-details
            @keypress.enter.prevent="searchSerial()"
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="table.headers"
          :items="table.data"
          :items-per-page="10"
          :loading="table.loading"
          item-key="id"
          :search="search"
          loading-text="Loading... Please wait"
          class="elevation-1"
        >
          <template
            v-for="header in table.headers.filter((header) =>
              header.hasOwnProperty('formatter')
            )"
            v-slot:[`item.${header.value}`]="{ value }"
          >
            {{ header.formatter(value) }}
          </template>

          <!-- <template v-slot:[`item.referenceNumber`]="{ item }">
            <a href="#" @click.prevent="searchOnu(item)">{{
              item.referenceNumber
            }}</a>
          </template> -->

          <template v-slot:[`item.isPostpaid`]="{ item }">
            {{ item.isPostpaid ? "Postpaid" : "Prepaid" }}
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <!-- <a @click="viewDrawDetail(item)">{{ item.name }}</a> -->
            <!-- <v-btn
              x-small
              color="primary"
              class="mr-1"
              dark
              @click="checkDuplicate(item)"
            >
              Check Duplicate</v-btn
            > -->

            <v-btn x-small color="pink" dark @click="deleteRecord(item)">
              Delete</v-btn
            >
          </template>
        </v-data-table>
      </v-card>
    </v-col>
    <snackbar></snackbar>
    <ConfirmationDiaglog ref="confirm"></ConfirmationDiaglog>
  </v-row>
</template>

<script>
// import moment from "moment";
import Snackbar from "../dialogs/Snackbar.vue";
import ConfirmationDiaglog from "../../views/dialogs/ConfirmationDiaglogv2.vue";
export default {
  name: "OltList",
  components: {
    Snackbar,
    ConfirmationDiaglog,
  },
  data() {
    return {
      search: "",
      serial: "",
      table: {
        expanded: [],
        singleExpand: false,
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,

        // "reference": "S2S_1709803405047",
        // "clientName": "Ceo Abalecio",
        // "soldDate": "2024-03-18 14:19:47",
        // "mobile": "639684263487",
        // "retailerId": "2100003707",
        // "retailerMobile": "639621149905",
        // "skuName": "Superfiber Installation + 30D+7D",
        // "skuDesc": "Installation fee 30 days internet package + 7 days free internet for 6 gadgets",
        // "serialNo": null,
        // "accountNo": null,
        // "ActivationDate": "NOT ACTIVATED",
        // "dref": "D4719905140324186218431493",
        // "responseCode": 0
        headers: [
          {
            text: "Reference #",
            sortable: false,
            value: "reference",
          },
          {
            text: "Client Name",
            sortable: false,
            value: "clientName",
          },

          {
            text: "Mobile Number",
            sortable: false,
            value: "mobile",
          },
          {
            text: "Retailer Id",
            sortable: false,
            value: "retailerId",
          },
          {
            text: "Retailer #",
            sortable: false,
            value: "retailerMobile",
          },
          {
            text: "SKU Name",
            sortable: false,
            value: "skuName",
          },

          { text: "Activation Date", sortable: false, value: "ActivationDate" },
          { text: "Serial #", sortable: true, value: "serialNo" },
          { text: "Account #", sortable: true, value: "accountNo" },
          // "serialNo": null,
        // "accountNo": null,
          // {
          //   text: "To Serial Number",
          //   sortable: false,
          //   value: "toSerialNumber",
          // },

          // {
          //   text: "Actions",
          //   sortable: false,
          //   value: "action",
          //   align: "center",
          // },
        ],
        data: [],
      },

      searchVal: "",
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async searchSerial() {
      this.table.loading = true;
      await this.$drs
        .post(`/broker/drs/check-s2s-refrence-no`, {
          referenceNo: this.searchVal,
        })
        .then((response) => {
          const newArr = response.data;
          console.log(newArr);
          this.table.data = newArr;
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    async deleteRecord(item) {
      console.log(item);
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to delete this record?"
        )
      ) {
        // console.log("adasd")

        this.table.loading = true;
        await this.$api
          .delete("/ibas/change-onu", {
            data: {
              _id: item._id,
            },
          })
          .then((response) => {
            const res = response.data;
            this.$store.dispatch("addSnackbarMessage", "Successfully deleted.");
            this.$store.dispatch("addSnackbar", true);

            if (res.status) {
              this.searchSerial();
            }
            // this.table.data = newArr;
            this.table.loading = false;
          })
          .catch((e) => {
            this.table.loading = false;
            console.log(e);
          });
      }
    },
  },
  created() {
    // this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>

<style scoped>
.p-0 {
  padding: 0px !important;
}

.sub-areas > div > table > thead > tr {
  background-color: red;
  border-radius: 10px;
}
</style>
